'use client';

import Link from 'next/link';

export default function GlobalError({
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  return (
    <html lang='en'>
      <body>
        <div className='flex min-h-screen flex-col items-center justify-center'>
          <h2 className='mb-4 text-xl text-white'>Something went wrong</h2>
          <div className='flex gap-4'>
            <button
              onClick={reset}
              className='rounded border px-4 py-2 text-white'
            >
              Try again
            </button>
            <Link href='/' className='rounded border px-4 py-2 text-white'>
              Home
            </Link>
          </div>
        </div>
      </body>
    </html>
  );
}
